import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	viewBox: "-4 -4 32 32",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "m10.737 19h4.21c2.78 0 5.053-2.25 5.053-5s-2.274-5-5.053-5h-10.947" }), /* @__PURE__ */ _jsx("path", { d: "m8 13-4-4 4-4" })]
	})
});
export default SvgUndo;
